/* Lipofem Chile — Shopify storefront interactions. */
(() => {
  'use strict';

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const config = window.LIPOFEM_CONFIG || {};
  const prices = config.pricesMXN || {};
  const comparePrices = config.comparePricesMXN || {};
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motion = () => reducedMotion.matches ? 'instant' : 'smooth';
  const money = value => typeof value === 'number' && Number.isFinite(value) && value >= 0
    ? new Intl.NumberFormat(config.priceLocale || 'es-CL', { style: 'currency', currency: config.currency || 'CLP', currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(value).replace(/\s/g, '')
    : null;
  const node = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  const button = (text, className, callback) => {
    const element = node('button', className, text);
    element.type = 'button';
    if (callback) element.addEventListener('click', callback);
    return element;
  };

  const announcement = node('div', 'lf-live');
  announcement.setAttribute('aria-live', 'polite');
  announcement.setAttribute('aria-atomic', 'true');
  document.body.append(announcement);
  let announceTimer;
  function announce(text) {
    clearTimeout(announceTimer);
    announcement.textContent = '';
    announceTimer = setTimeout(() => { announcement.textContent = text; }, 30);
  }

  // Native dialogs provide focus containment, Escape dismissal and focus return.
  function makeDialog(id, title, extraClass = '') {
    const dialog = node('dialog', `lf-dialog ${extraClass}`);
    dialog.id = id;
    dialog.setAttribute('aria-labelledby', `${id}-heading`);
    const header = node('div', 'lf-dialog__header');
    const heading = node('h2', '', title);
    heading.id = `${id}-heading`;
    const close = button('×', 'lf-dialog__close', () => dialog.close());
    close.setAttribute('aria-label', 'Cerrar');
    header.append(heading, close);
    const content = node('div', 'lf-dialog__content');
    dialog.append(header, content);
    document.body.append(dialog);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.body.classList.toggle('lf-modal-open', Boolean($('dialog[open]')));
    });
    return { dialog, content, heading };
  }
  function openDialog(dialog) {
    const menu = $('.site-nav');
    if (menu) menu.classList.remove('is-open');
    $$('[data-menu-toggle]').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('lf-menu-open');
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('lf-modal-open');
  }

  const information = makeDialog('lf-information', 'Lipofem Chile');
  const informationCopy = {
    contacto: ['Contacto', `Ubicación: ${config.supportLocation || 'Tarapaca 1153, Santiago de Chile'}.`],
    suscripcion: ['Suscripción VIP', 'La suscripción VIP de Lipofem Chile estará disponible próximamente.'],
    cuenta: ['Mi cuenta', 'Podrás crear tu cuenta cuando se habiliten las compras en Chile.'],
    favoritos: ['Lipofem en tus favoritos', 'Guardamos Lipofem en los favoritos de este dispositivo.']
  };
  function showInformation(kind) {
    const destination = kind === 'cuenta' ? config.accountUrl : config.policyUrls?.[kind];
    if (typeof destination === 'string' && destination.startsWith('/') && !destination.startsWith('//')) {
      window.location.assign(destination);
      return;
    }
    const copy = informationCopy[kind] || informationCopy.contacto;
    information.heading.textContent = copy[0];
    information.content.replaceChildren(node('p', '', copy[1]));
    if (kind === 'contacto' && typeof config.supportEmail === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(config.supportEmail)) {
      const contact = node('a', 'lf-contact-link', config.supportEmail);
      contact.href = `mailto:${config.supportEmail}`;
      information.content.append(contact);
    }
    openDialog(information.dialog);
  }
  $$('[data-local-info]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    showInformation(link.dataset.localInfo);
  }));
  $$('[data-account-toggle]').forEach(trigger => trigger.addEventListener('click', () => showInformation('cuenta')));

  // Gallery keeps all six original placements and a single full-size image.
  const productImage = $('#product-image');
  const thumbnails = $$('.gallery-thumb');
  const gallery = $('.product-gallery');
  let galleryIndex = 0;
  const galleryImages = thumbnails.map(thumb => {
    const img = $('img', thumb);
    return { src: thumb.dataset.src || img?.getAttribute('src') || '', alt: img?.alt || 'Lipofem Chile' };
  });
  const zoom = makeDialog('lf-zoom', 'Lipofem · Galería', 'lf-dialog--zoom');
  const zoomImage = node('img', 'lf-zoom-image');
  const zoomControls = node('div', 'lf-zoom-controls');
  const zoomPrevious = button('←', 'lf-round-button', () => selectImage(galleryIndex - 1));
  zoomPrevious.setAttribute('aria-label', 'Imagen anterior');
  const zoomNext = button('→', 'lf-round-button', () => selectImage(galleryIndex + 1));
  zoomNext.setAttribute('aria-label', 'Imagen siguiente');
  const zoomCounter = node('span');
  zoomCounter.setAttribute('aria-live', 'polite');
  zoomControls.append(zoomPrevious, zoomCounter, zoomNext);
  zoom.content.append(zoomImage, zoomControls);
  function selectImage(index, shouldAnnounce = true) {
    if (!productImage || !galleryImages.length) return;
    galleryIndex = (index + galleryImages.length) % galleryImages.length;
    const image = galleryImages[galleryIndex];
    productImage.src = image.src;
    productImage.alt = image.alt;
    productImage.removeAttribute('srcset');
    zoomImage.src = image.src;
    zoomImage.alt = image.alt;
    const counter = `${galleryIndex + 1} / ${galleryImages.length}`;
    if ($('#gallery-counter')) $('#gallery-counter').textContent = counter;
    zoomCounter.textContent = counter;
    thumbnails.forEach((thumb, i) => {
      thumb.classList.toggle('active', i === galleryIndex);
      thumb.setAttribute('aria-pressed', String(i === galleryIndex));
      thumb.setAttribute('aria-current', String(i === galleryIndex));
      thumb.setAttribute('aria-label', `Ver imagen ${i + 1} de ${galleryImages.length}`);
    });
    if (shouldAnnounce) announce(`Imagen ${galleryIndex + 1} de ${galleryImages.length}`);
  }
  thumbnails.forEach((thumb, index) => thumb.addEventListener('click', () => selectImage(index)));
  $('#gallery-prev')?.addEventListener('click', () => selectImage(galleryIndex - 1));
  $('#gallery-next')?.addEventListener('click', () => selectImage(galleryIndex + 1));
  const zoomTarget = productImage?.closest('button') || productImage;
  if (zoomTarget) {
    if (zoomTarget.tagName !== 'BUTTON') {
      zoomTarget.tabIndex = 0;
      zoomTarget.setAttribute('role', 'button');
    }
    zoomTarget.setAttribute('aria-label', 'Ampliar imagen del producto');
    zoomTarget.setAttribute('aria-haspopup', 'dialog');
    let pointerStart;
    let suppressClick = false;
    zoomTarget.addEventListener('pointerdown', event => {
      pointerStart = { x: event.clientX, y: event.clientY };
      suppressClick = false;
    });
    zoomTarget.addEventListener('pointerup', event => {
      if (!pointerStart) return;
      const distance = event.clientX - pointerStart.x;
      if (Math.abs(distance) > 50 && Math.abs(distance) > Math.abs(event.clientY - pointerStart.y)) {
        suppressClick = true;
        selectImage(galleryIndex + (distance < 0 ? 1 : -1));
      }
      pointerStart = null;
    });
    zoomTarget.addEventListener('click', () => {
      if (!suppressClick) openDialog(zoom.dialog);
      suppressClick = false;
    });
    if (zoomTarget.tagName !== 'BUTTON') zoomTarget.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openDialog(zoom.dialog);
      }
    });
  }
  function galleryKeyboard(event) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    selectImage(event.key === 'Home' ? 0 : event.key === 'End' ? galleryImages.length - 1 : galleryIndex + (event.key === 'ArrowLeft' ? -1 : 1));
  }
  gallery?.addEventListener('keydown', galleryKeyboard);
  zoom.dialog.addEventListener('keydown', galleryKeyboard);
  selectImage(0, false);

  // Packs use native radio controls, including keyboard arrow navigation.
  const radios = $$('input[name="renova_bundle"]');
  const packs = new Map(radios.map(radio => [radio.value, {
    id: radio.value,
    label: radio.dataset.bundleLabel || $('.renova-bundle__title', radio.closest('.renova-bundle'))?.textContent.trim() || 'Pack Lipofem',
    price: prices[radio.value],
    variantId: String(config.variantIds?.[radio.value] || ''),
    available: config.variantAvailable?.[radio.value] !== false,
    units: Number.parseInt(radio.dataset.qty, 10) || 1
  }]));
  let hasSelectedPack = false;
  function updatePacks() {
    radios.forEach(radio => radio.closest('.renova-bundle')?.classList.toggle('active', radio.checked));
  }
  radios.forEach(radio => {
    const card = radio.closest('.renova-bundle');
    radio.classList.add('lf-pack-radio');
    radio.addEventListener('change', () => { hasSelectedPack = true; updatePacks(); updateBuyButton(); });
    const mainPrice = $('.renova-bundle__main-price', card);
    const oldPrice = $('.renova-bundle__old-price', card);
    if (mainPrice) mainPrice.textContent = money(prices[radio.value]) || 'Próximamente';
    if (mainPrice) mainPrice.classList.toggle('lf-price-pending', !money(prices[radio.value]));
    if (oldPrice) {
      oldPrice.textContent = money(comparePrices[radio.value]) || '';
      oldPrice.hidden = !money(comparePrices[radio.value]);
    }
  });
  updatePacks();

  // Shopify is the source of truth. Each variant is one complete pack, regardless of bottle count.
  const routeRoot = window.Shopify?.routes?.root || '/';
  const shopRoute = path => `${routeRoot.endsWith('/') ? routeRoot : `${routeRoot}/`}${path}`;
  const validVariant = value => /^\d+$/.test(value) && Number.isSafeInteger(Number(value)) && Number(value) > 0;
  const packByVariant = new Map([...packs.values()].filter(pack => validVariant(pack.variantId)).map(pack => [pack.variantId, pack]));
  const variantFromURL = new URLSearchParams(window.location.search).get('variant');
  const initialRadio = radios.find(radio => packs.get(radio.value)?.variantId === variantFromURL);
  if (initialRadio) {
    initialRadio.checked = true;
    hasSelectedPack = true;
    updatePacks();
  }
  const buyButton = $('#renova-bundle-cta');
  const buyButtonText = buyButton?.textContent || 'Agregar al carrito';
  const cart = makeDialog('lf-cart', 'Tu carrito', 'lf-dialog--cart');
  const cartItems = node('div', 'lf-cart-items');
  const cartSummary = node('div', 'lf-cart-summary');
  const checkoutStatus = node('p', 'lf-checkout-status');
  checkoutStatus.setAttribute('role', 'status');
  checkoutStatus.setAttribute('aria-live', 'polite');
  checkoutStatus.tabIndex = -1;
  let cartState = null;
  let cartBusy = false;
  let cartUnconfirmed = false;
  const checkout = button('Finalizar compra', 'lf-primary-button', () => {
    if (cartBusy || cartUnconfirmed || !cartState?.item_count) return;
    window.location.assign(shopRoute('checkout'));
  });
  const retryCart = button('Actualizar carrito', 'lf-text-button', () => refreshCart());
  retryCart.hidden = true;
  const continueShopping = button('Seguir explorando', 'lf-text-button', () => cart.dialog.close());
  cart.content.append(cartItems, cartSummary, checkout, checkoutStatus, retryCart, continueShopping);

  function updateBuyButton() {
    if (!buyButton) return;
    const selected = $('input[name="renova_bundle"]:checked');
    const pack = packs.get(selected?.value);
    buyButton.disabled = cartBusy || !pack?.available || !validVariant(pack?.variantId || '');
    buyButton.textContent = cartBusy ? 'Actualizando…' : !pack?.available ? 'Agotado' : !validVariant(pack?.variantId || '') ? 'No disponible' : buyButtonText;
    buyButton.setAttribute('aria-busy', String(cartBusy));
  }
  function setBusy(busy) {
    cartBusy = busy;
    cart.content.setAttribute('aria-busy', String(busy));
    updateBuyButton();
    checkout.disabled = busy || cartUnconfirmed || !cartState?.item_count;
    retryCart.disabled = busy;
    $$('[data-cart-action]', cartItems).forEach(control => {
      control.disabled = busy || control.dataset.limit === 'true';
    });
  }
  function cartMoney(cents) {
    if (typeof cents !== 'number' || !Number.isFinite(cents)) return '—';
    const currency = cartState?.currency || config.currency || 'CLP';
    return `${new Intl.NumberFormat(config.priceLocale || 'es-CL', {
      style: 'currency', currency, currencyDisplay: 'narrowSymbol', minimumFractionDigits: 0, maximumFractionDigits: 2
    }).format(cents / 100).replace(/\s/g, '')} ${currency}`;
  }
  async function cartRequest(path, body) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(shopRoute(path), {
        method: body === undefined ? 'GET' : 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json', ...(body === undefined ? {} : { 'Content-Type': 'application/json' }) },
        ...(body === undefined ? {} : { body: JSON.stringify(body) }),
        signal: controller.signal
      });
      const data = await response.json().catch(() => null);
      if (!response.ok) {
        const error = new Error(typeof data?.description === 'string' ? data.description : 'No se pudo actualizar el carrito. Intenta nuevamente.');
        error.status = response.status;
        throw error;
      }
      if (!data || typeof data !== 'object') throw new Error('No pudimos confirmar el carrito. Actualízalo antes de continuar.');
      return data;
    } catch (error) {
      if (error.name === 'AbortError') throw new Error('La conexión tardó demasiado. Actualiza el carrito para confirmar tu selección.');
      if (error instanceof TypeError) throw new Error('No pudimos conectar con la tienda. Revisa tu conexión y actualiza el carrito.');
      throw error;
    } finally {
      clearTimeout(timeout);
    }
  }
  function acceptCart(data) {
    if (!Array.isArray(data?.items) || !Number.isInteger(data.item_count) || !Number.isFinite(data.total_price)) {
      throw new Error('No pudimos confirmar el carrito. Actualízalo antes de continuar.');
    }
    cartState = data;
    cartUnconfirmed = false;
    retryCart.hidden = true;
    renderCart();
  }
  function showCartError(error) {
    checkoutStatus.textContent = error.message || 'No se pudo actualizar el carrito. Intenta nuevamente.';
    retryCart.hidden = false;
    announce(checkoutStatus.textContent);
    if (cart.dialog.open) checkoutStatus.focus();
  }
  function renderCart() {
    const count = cartState?.item_count || 0;
    $$('[data-cart-count], [data-testid="cart-bubble"]').forEach(badge => {
      if (cartState) badge.textContent = String(count);
      badge.hidden = cartState ? count === 0 : badge.hidden;
      if (cartState) {
        badge.classList.toggle('hidden', count === 0);
        badge.closest('.cart-bubble')?.classList.toggle('visually-hidden', count === 0);
      }
    });
    $$('[data-open-cart], [data-testid="cart-drawer-trigger"]').forEach(trigger => {
      trigger.setAttribute('aria-label', count ? `Carrito: ${count} ${count === 1 ? 'pack' : 'packs'}` : 'Carrito');
      trigger.setAttribute('aria-controls', cart.dialog.id);
    });
    cartItems.replaceChildren();
    cartSummary.hidden = !count;
    checkout.hidden = !count;
    if (!cartState) {
      cartItems.append(node('p', 'lf-cart-muted', cartBusy ? 'Cargando tu carrito…' : 'Actualiza para ver tu carrito.'));
      setBusy(cartBusy);
      return;
    }
    if (!count) {
      cartItems.append(node('p', 'lf-cart-empty', 'Tu carrito está vacío.'), node('p', 'lf-cart-muted', 'Elige tu pack de Lipofem para comenzar.'));
      setBusy(cartBusy);
      return;
    }
    cartState.items.forEach(item => {
      const pack = packByVariant.get(String(item.variant_id));
      const label = pack?.label || (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : item.product_title || item.title);
      const row = node('article', 'lf-cart-item');
      const img = node('img', 'lf-cart-item__image');
      img.src = item.featured_image?.url || item.image || galleryImages[0]?.src || productImage?.src || '';
      img.alt = item.featured_image?.alt || item.product_title || 'Lipofem';
      const details = node('div', 'lf-cart-item__details');
      details.append(node('h3', '', item.product_title || 'Lipofem'), node('p', 'lf-cart-item__pack', label), node('p', 'lf-cart-item__price', cartMoney(item.final_price ?? item.price)));
      const quantity = node('div', 'lf-cart-quantity');
      const minus = button('−', '', () => changeQuantity(item, item.quantity - 1, -1));
      minus.setAttribute('aria-label', `Reducir cantidad de ${label}`);
      minus.dataset.limit = String(item.quantity <= 1);
      minus.dataset.cartAction = 'quantity';
      minus.dataset.quantityId = item.key;
      minus.dataset.delta = '-1';
      const plus = button('+', '', () => changeQuantity(item, item.quantity + 1, 1));
      plus.setAttribute('aria-label', `Aumentar cantidad de ${label}`);
      plus.dataset.limit = String(item.quantity >= 99);
      plus.dataset.cartAction = 'quantity';
      plus.dataset.quantityId = item.key;
      plus.dataset.delta = '1';
      const amount = node('span', '', String(item.quantity));
      amount.setAttribute('aria-label', `${item.quantity} ${item.quantity === 1 ? 'pack' : 'packs'}`);
      quantity.append(minus, amount, plus);
      const remove = button('Eliminar', 'lf-text-button lf-cart-remove', () => changeQuantity(item, 0));
      remove.dataset.cartAction = 'remove';
      remove.setAttribute('aria-label', `Eliminar ${label}`);
      const actions = node('div', 'lf-cart-item__actions');
      actions.append(quantity, remove);
      details.append(actions);
      row.append(img, details);
      cartItems.append(row);
    });
    cartSummary.replaceChildren(node('strong', '', 'Total'), node('span', '', cartMoney(cartState.total_price)));
    setBusy(cartBusy);
  }
  async function refreshCart({ restoreSelection = false } = {}) {
    if (cartBusy) return;
    checkoutStatus.textContent = '';
    setBusy(true);
    if (!cartState) renderCart();
    try {
      acceptCart(await cartRequest('cart.js'));
      if (restoreSelection && !hasSelectedPack) {
        const pack = cartState.items.map(item => packByVariant.get(String(item.variant_id))).find(Boolean);
        const radio = radios.find(control => control.value === pack?.id);
        if (radio) { radio.checked = true; updatePacks(); }
      }
    } catch (error) {
      cartUnconfirmed = true;
      showCartError(error);
    } finally {
      setBusy(false);
      if (!cartState) renderCart();
    }
  }
  async function mutateCart(path, payload, successMessage, restoreFocus) {
    if (cartBusy) return;
    checkoutStatus.textContent = '';
    setBusy(true);
    try {
      const result = await cartRequest(path, payload);
      // add.js returns added lines, whereas change.js returns the whole cart.
      acceptCart(path === 'cart/add.js' ? await cartRequest('cart.js') : result);
      announce(successMessage);
      return true;
    } catch (error) {
      // A stock limit or interrupted response can still change Shopify's cart; never retry a write automatically.
      cartUnconfirmed = true;
      try { acceptCart(await cartRequest('cart.js')); } catch { /* Keep last confirmed contents and block checkout. */ }
      showCartError(error);
      return false;
    } finally {
      setBusy(false);
      if (restoreFocus && !checkoutStatus.textContent) restoreFocus();
    }
  }
  async function changeQuantity(item, quantity, delta) {
    if (!Number.isInteger(quantity) || quantity < 0 || quantity > 99 || cartBusy) return;
    const label = packByVariant.get(String(item.variant_id))?.label || item.variant_title || item.product_title || 'Producto';
    await mutateCart('cart/change.js', { id: item.key, quantity }, quantity ? `${label}: ${quantity} ${quantity === 1 ? 'pack' : 'packs'}` : `${label} eliminado del carrito`, () => {
      const updated = cartState.items.find(entry => entry.key === item.key) || cartState.items.find(entry => entry.variant_id === item.variant_id);
      const controls = $$('[data-quantity-id]', cart.dialog).filter(control => control.dataset.quantityId === updated?.key);
      const preferred = controls.find(control => control.dataset.delta === String(delta) && !control.disabled) || controls.find(control => !control.disabled);
      (preferred || $('.lf-dialog__close', cart.dialog))?.focus();
    });
  }
  function openCart(event) {
    event?.preventDefault();
    openDialog(cart.dialog);
    $$('[data-open-cart], [data-testid="cart-drawer-trigger"]').forEach(trigger => trigger.setAttribute('aria-expanded', 'true'));
    refreshCart();
  }
  cart.dialog.addEventListener('close', () => $$('[data-open-cart], [data-testid="cart-drawer-trigger"]').forEach(trigger => trigger.setAttribute('aria-expanded', 'false')));
  $$('[data-open-cart], [data-testid="cart-drawer-trigger"]').forEach(trigger => trigger.addEventListener('click', openCart));
  buyButton?.addEventListener('click', async event => {
    event.preventDefault();
    if (cartBusy) return;
    const selected = $('input[name="renova_bundle"]:checked');
    const pack = packs.get(selected?.value);
    if (!pack?.available || !validVariant(pack?.variantId || '')) return;
    openDialog(cart.dialog);
    $$('[data-open-cart], [data-testid="cart-drawer-trigger"]').forEach(trigger => trigger.setAttribute('aria-expanded', 'true'));
    await mutateCart('cart/add.js', { items: [{ id: Number(pack.variantId), quantity: 1 }] }, `${pack.label} agregado al carrito`);
  });
  // Restore Shopify's session cart on load, including returning from checkout or another tab.
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCart(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refreshCart(); });
  renderCart();
  refreshCart({ restoreSelection: true });

  // All horizontal sections use native scrolling, with buttons and keyboard access.
  function bindTrack(trackId, previousId, nextId, cardSelector) {
    const track = document.getElementById(trackId);
    if (!track) return;
    const previous = document.getElementById(previousId);
    const next = document.getElementById(nextId);
    track.tabIndex = 0;
    track.setAttribute('aria-label', trackId === 'ingredientsTrack' ? 'Ingredientes de Lipofem' : 'Reseñas de compradoras');
    const sync = () => {
      const end = Math.max(0, track.scrollWidth - track.clientWidth);
      if (previous) previous.disabled = track.scrollLeft <= 3;
      if (next) next.disabled = track.scrollLeft >= end - 3;
    };
    const step = direction => {
      const card = $(cardSelector, track);
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || track.clientWidth) + gap), behavior: motion() });
    };
    previous?.addEventListener('click', () => step(-1));
    next?.addEventListener('click', () => step(1));
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home' || event.key === 'End') track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: motion() });
      else step(event.key === 'ArrowLeft' ? -1 : 1);
    });
    let drag;
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, a, input')) return;
      drag = { x: event.clientX, scroll: track.scrollLeft };
      track.setPointerCapture(event.pointerId);
      track.classList.add('is-dragging');
    });
    track.addEventListener('pointermove', event => {
      if (!drag) return;
      track.scrollLeft = drag.scroll - (event.clientX - drag.x);
    });
    const endDrag = event => {
      drag = null;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('dragstart', event => event.preventDefault());
    track.addEventListener('scroll', sync, { passive: true });
    new ResizeObserver(sync).observe(track);
    sync();
  }
  bindTrack('renova-reviews-track', 'renova-review-prev', 'renova-review-next', '.renova-bundles__review-card');
  bindTrack('ingredientsTrack', 'ingredientsPrev', 'ingredientsNext', '.ingredient-card');
  bindTrack('testimonialsSlider', 'testimonialsPrev', 'testimonialsNext', '.testimonial-card');

  const timeline = $('#timelineWrapper');
  const progress = $('#progressFill');
  const timelineItems = $$('.timeline-item');
  if (timeline && progress) {
    let scheduled = false;
    const updateTimeline = () => {
      scheduled = false;
      const trigger = window.innerHeight * 0.6;
      const rect = timeline.getBoundingClientRect();
      progress.style.height = `${Math.max(0, Math.min(100, (trigger - rect.top) / Math.max(rect.height, 1) * 100))}%`;
      timelineItems.forEach(item => {
        const position = ($('.timeline-node', item) || item).getBoundingClientRect();
        item.classList.toggle('active', position.top + position.height / 2 <= trigger);
      });
    };
    const schedule = () => {
      if (!scheduled) requestAnimationFrame(updateTimeline);
      scheduled = true;
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    updateTimeline();
  }

  // In-page navigation and a compact mobile menu retain the original header.
  const menu = $('.site-nav');
  const menuTriggers = $$('[data-menu-toggle]');
  if (menu) {
    menu.id = menu.id || 'lf-navigation';
    menuTriggers.forEach(trigger => trigger.setAttribute('aria-controls', menu.id));
  }
  function closeMenu() {
    menu?.classList.remove('is-open');
    document.body.classList.remove('lf-menu-open');
    menuTriggers.forEach(trigger => { trigger.setAttribute('aria-expanded', 'false'); trigger.setAttribute('aria-label', 'Abrir menú'); });
  }
  menuTriggers.forEach(trigger => trigger.addEventListener('click', () => {
    const open = !menu?.classList.contains('is-open');
    menu?.classList.toggle('is-open', open);
    document.body.classList.toggle('lf-menu-open', open);
    menuTriggers.forEach(item => { item.setAttribute('aria-expanded', String(open)); item.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú'); });
  }));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu?.classList.contains('is-open')) {
      closeMenu();
      menuTriggers[0]?.focus();
    }
  });
  document.addEventListener('click', event => {
    if (menu?.classList.contains('is-open') && !event.target.closest('#site-header')) closeMenu();
  });
  $$('a[href^="#"]').forEach(link => link.addEventListener('click', event => {
    if (link.hasAttribute('data-local-info')) return;
    const hash = link.getAttribute('href');
    const target = hash === '#' ? document.body : document.getElementById(hash.slice(1));
    if (!target) return;
    event.preventDefault();
    closeMenu();
    target.scrollIntoView({ behavior: motion(), block: 'start' });
    if (target !== document.body && !target.hasAttribute('tabindex')) target.tabIndex = -1;
    if (target !== document.body) target.focus({ preventScroll: true });
  }));

  const search = makeDialog('lf-search', 'Buscar', 'lf-dialog--search');
  const searchForm = node('form', 'lf-search-form');
  searchForm.setAttribute('role', 'search');
  const searchLabel = node('label', 'lf-live', 'Buscar productos');
  searchLabel.htmlFor = 'lf-search-input';
  const searchInput = node('input', 'lf-search-input');
  searchInput.id = 'lf-search-input';
  searchInput.type = 'search';
  searchInput.placeholder = 'Buscar en Lipofem…';
  searchInput.autocomplete = 'off';
  const searchResults = node('div', 'lf-search-results');
  searchResults.setAttribute('aria-live', 'polite');
  searchForm.append(searchLabel, searchInput);
  search.content.append(searchForm, searchResults);
  const normalize = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const searchText = normalize('Lipofem suplemento mujer mujeres energia figura metabolismo natural pack chile ' + ($('.santi-hero')?.textContent || ''));
  const updateSearch = () => {
    const query = normalize(searchInput.value.trim());
    searchResults.replaceChildren();
    if (query && !query.split(/\s+/).every(word => searchText.includes(word))) {
      searchResults.append(node('p', '', `No encontramos resultados para “${searchInput.value.trim()}”.`));
      return;
    }
    const result = button('', 'lf-search-result', () => {
      search.dialog.close();
      ($('.product-layout') || $('.renova-bundles'))?.scrollIntoView({ behavior: motion() });
    });
    const image = node('img');
    image.src = galleryImages[0]?.src || productImage?.src || '';
    image.alt = '';
    const copy = node('span');
    copy.append(node('strong', '', 'Lipofem — Recupera tu figura y energía'), node('span', '', 'Ver producto'));
    result.append(image, copy);
    searchResults.append(result);
  };
  searchInput.addEventListener('input', updateSearch);
  searchForm.addEventListener('submit', event => {
    event.preventDefault();
    updateSearch();
  });
  $$('[data-search-toggle]').forEach(trigger => trigger.addEventListener('click', () => {
    openDialog(search.dialog);
    updateSearch();
    searchInput.focus();
  }));
  $('.renova-bundles__seller-follow')?.addEventListener('click', event => {
    event.currentTarget.textContent = 'Siguiendo';
    event.currentTarget.setAttribute('aria-pressed', 'true');
    try { localStorage.setItem('lipofem.favorite', '1'); } catch { /* Optional preference. */ }
    showInformation('favoritos');
  });
  try {
    if (localStorage.getItem('lipofem.favorite') === '1') {
      const follow = $('.renova-bundles__seller-follow');
      if (follow) { follow.textContent = 'Siguiendo'; follow.setAttribute('aria-pressed', 'true'); }
    }
  } catch { /* Storage can be disabled. */ }
})();
